import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums';

type DangerFilledIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'> & {
  size?: IconSize;
};

export const DangerFilledIcon = ({
  strokeWidth,
  size = IconSize.Standard,
  ...props
}: DangerFilledIconProps) => {
  const dimensions = size === IconSize.Mini ? 16 : 24;

  return (
    <BaseIcon
      width={dimensions}
      height={dimensions}
      viewBox="0 0 14 13"
      fill="none"
      strokeWidth={strokeWidth}
      {...props}
    >
      <path d="M1 12.5L7.00002 1L13 12.5H1Z" fill="currentColor" />
      <path
        d="M7.00001 0.5C7.18625 0.5 7.35718 0.60346 7.44337 0.768555L13.4434 12.2686C13.5242 12.4234 13.5182 12.6094 13.4277 12.7588C13.3371 12.9083 13.1748 13 13 13H1.00001C0.825186 13 0.6629 12.9083 0.572275 12.7588C0.481861 12.6094 0.475848 12.4234 0.55665 12.2686L6.55665 0.768555L6.59278 0.709961C6.68574 0.579391 6.83694 0.500005 7.00001 0.5ZM1.8252 12H12.1748L7.00001 2.08105L1.8252 12Z"
        fill="currentColor"
      />
      <path
        d="M6.5 8.5V5C6.5 4.72386 6.72386 4.5 7 4.5C7.27614 4.5 7.5 4.72386 7.5 5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5Z"
        fill="white"
      />
      <path
        d="M7.5 10.5C7.5 10.7761 7.27614 11 7 11C6.72386 11 6.5 10.7761 6.5 10.5C6.5 10.2239 6.72386 10 7 10C7.27614 10 7.5 10.2239 7.5 10.5Z"
        fill="white"
      />
    </BaseIcon>
  );
};

DangerFilledIcon.displayName = 'DangerFilledIcon';
